import apiClient from './client';
import type { Cliente, DireccionEntrega, Pedido, PaginatedResponse } from '@/types';

export const clientesService = {
  async getClientes(params: {
    comisionistaId?: number;
    search?: string;
    ciudad?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Cliente>> {
    const { data } = await apiClient.get<PaginatedResponse<Cliente>>('/clientes', { params });
    return data;
  },

  async getClienteById(id: string): Promise<Cliente> {
    const { data } = await apiClient.get<Cliente>(`/clientes/${id}`);
    return data;
  },

  async getDirecciones(clienteId: string): Promise<DireccionEntrega[]> {
    const { data } = await apiClient.get<DireccionEntrega[]>(`/clientes/${clienteId}/direcciones`);
    return data;
  },

  async getPedidos(
    clienteId: string,
    params: {
      page?: number;
      limit?: number;
      fechaDesde?: string;
      fechaHasta?: string;
    }
  ): Promise<PaginatedResponse<Pedido> & { totalPedidos: number; saldoPendiente: number }> {
    const { data } = await apiClient.get(`/clientes/${clienteId}/pedidos`, { params });
    return data;
  },
};
